export const bubbleStories = [
    {
        label: 'Using formatted values',
        link: {
            kind: 'Bubble',
            story: 'with formatted values',
        },
    },
    {
        label: 'Using custom tooltip',
        link: {
            kind: 'Bubble',
            story: 'custom tooltip',
        },
    },
]
